import { useNavigate } from 'react-router-dom';

const BlogHero = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* ── HERO ──────────────────────────────────────────────────────── */}
      <div className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/269b4d85cb5ba680091775e4344780ce.jpg"
            alt="Spirituele Bescherming"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050010]/75 via-[#050010]/60 to-[#050010]" />
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full py-24">
          <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-4">✦ Sjamanisme &amp; Spirituele Kennis ✦</p>
          <h1 className="text-4xl lg:text-6xl font-black text-white leading-tight mb-6">
            Bescherming van Jezelf,<br />
            <span className="text-transparent bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text">
              Je Kind en Je Omgeving
            </span>
          </h1>
          <p className="text-white/65 text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Onrust, energieverlies, een baby die 's nachts schrikt — soms is er meer aan de hand dan je ziet.
            Ontdek bewezen sjamaanse beschermingskennis voor gezin, huis en werk.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/consultations')}
              className="px-8 py-4 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white font-bold rounded-full whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer flex items-center gap-2"
            >
              <i className="ri-calendar-line" />
              Plan een consult
            </button>
            <button
              onClick={() => navigate('/shop')}
              className="px-8 py-4 border border-violet-500/40 text-violet-300 font-semibold rounded-full whitespace-nowrap hover:bg-violet-500/10 transition-colors cursor-pointer flex items-center gap-2"
            >
              <i className="ri-shield-line" />
              Ontdek jouw bescherming
            </button>
          </div>
        </div>
      </div>

      {/* ── INTRO HERKENNING ──────────────────────────────────────────── */}
      <section className="py-16 bg-[#050010]">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-10">
            <p className="text-violet-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Herken jij dit? ✦</p>
            <h2 className="text-3xl font-bold text-white mb-4">
              Soms is er meer aan de hand<br />
              <span className="text-violet-400">dan je kunt verklaren</span>
            </h2>
            <p className="text-white/55 text-base leading-relaxed max-w-2xl mx-auto">
              Vermoeidheid zonder duidelijke reden. Een baby die elke nacht schrikt. Spanning in huis zonder aanleiding.
              Energieverlies na contact met bepaalde mensen. Dit zijn signalen — geen toeval.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: 'ri-moon-line', label: 'Baby schrikt \'s nachts wakker', desc: 'Herhaaldelijk en onverklaarbaar' },
              { icon: 'ri-heart-pulse-line', label: 'Energieverlies zonder reden', desc: 'Na contact met bepaalde mensen' },
              { icon: 'ri-home-heart-line', label: 'Onrust in huis', desc: 'Spanning zonder duidelijke oorzaak' },
              { icon: 'ri-briefcase-line', label: 'Stagnatie in werk of zaak', desc: 'Ondanks inspanning geen vooruitgang' },
            ].map(item => (
              <div key={item.label} className="flex flex-col items-center text-center p-5 bg-violet-600/8 border border-violet-500/15 rounded-2xl">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-violet-600/20 mb-3">
                  <i className={`${item.icon} text-violet-400 text-xl`} />
                </div>
                <p className="text-white font-semibold text-sm mb-1">{item.label}</p>
                <p className="text-white/40 text-xs">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogHero;
